import { ethers } from "ethers";
import tokenabi from "./abis/chainedxtoken.json";
import stakeabi from "./abis/chainedxstake.json";

import { CHX_STAKING_ADDRESS, CHX_TOKEN_ADDRESS } from "./address";

export const getStakingContract = (provider, address: string) => {
  const etherProvider = new ethers.providers.Web3Provider(provider);
  const signer = etherProvider.getSigner(address);
  const chainedxStake = new ethers.Contract(
    CHX_STAKING_ADDRESS,
    stakeabi,
    signer
  );

  return chainedxStake;
};

export const getTokenBalance = async (provider, address: any) => {
  const etherProvider = new ethers.providers.Web3Provider(provider);
  const signer = etherProvider.getSigner(address);
  const CHXTokenContract = new ethers.Contract(
    CHX_TOKEN_ADDRESS,
    tokenabi,
    signer
  );

  const userBalanceInHex = await CHXTokenContract.balanceOf(address);
  const userBalance = userBalanceInHex.toString();
  const formatEther = ethers.utils.formatEther(userBalance);

  return Number(formatEther);
};

export const getUserAllowance = async (provider, address: string) => {
  const etherProvider = new ethers.providers.Web3Provider(provider);
  const signer = etherProvider.getSigner(address);
  const CHXTokenContract = new ethers.Contract(
    CHX_TOKEN_ADDRESS,
    tokenabi,
    signer
  );

  const userAllowanceInHex = await CHXTokenContract.allowance(
    address,
    CHX_STAKING_ADDRESS
  );
  const userAllowance = userAllowanceInHex.toString();
  const formatEther = ethers.utils.formatEther(userAllowance);
  return Number(formatEther);
};

export const getUserDetails = async (provider, address: string) => {
  const chainedxStake = getStakingContract(provider, address);

  const userDetails = await chainedxStake.getUserDetails(address);
  const formatTotalStaked = ethers.utils.formatEther(userDetails[0].toString());
  return {
    totalStaked: Number(formatTotalStaked),
  };
};

export const getRewardAmount = async (
  provider,
  address: string,
  userStaked: number
) => {
  try {
    const chainedxStake = getStakingContract(provider, address);

    const rewards = await chainedxStake.rewardPerBlockAddress(address);
    const formatEther = ethers.utils.formatEther(rewards.toString());

    return Number(formatEther);
  } catch (error) {
    return 0;
  }
};
